import { InjectionToken } from '@angular/core';

/**
 * Base path of the Spectrum backend for the current app,
 * e.g. `https://spectrum.myakshar.com/spectrum-api`.
 * Provided per-app in app.config.ts; consumed by the shared layout
 * components (header bar, school change) to reach the generic
 * Spectrum endpoints (security/modules, documents/get, auth user-access).
 */
export const SPECTRUM_API_PATH = new InjectionToken<string>('SPECTRUM_API_PATH');

/** Central portal base URL (no trailing slash). Provided per-app from environment.authBaseUrl. */
export const SPECTRUM_AUTH_API = new InjectionToken<string>('SPECTRUM_AUTH_API');

/**
 * In-app route the session-expiry redirect goes to instead of the central
 * portal. Optional — only apps with their own sign-in screen provide it
 * (System Admin's support login at '/login'); everyone else falls back to
 * the portal.
 */
export const SPECTRUM_SESSION_LOGIN_ROUTE = new InjectionToken<string>('SPECTRUM_SESSION_LOGIN_ROUTE');
